// extracted by mini-css-extract-plugin
module.exports =  {"root":"YqtHmz_YZIoCVplQamup","labels":"lUc1IOkqgwYmZKNY60Ut","dimensions":"r03xvH6DAQHHWm5uhwgG"};